import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    
  const navigate = useNavigate();

  return (
    
    <div className="py-20 flex items-center justify-center">
    <div className="max-w-md w-full space-y-8 bg-white p-8  rounded-xl shadow-2xl text-center animate-fade-in-up">
      
      <div className="flex justify-center">
        <div className="h-24 w-24 bg-red-100 rounded-full flex items-center justify-center animate-pulse shadow-lg transform transition-transform duration-300 hover:scale-110">
          <svg className="h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>
      </div>
  
      <h2 className="mt-6 text-3xl font-extrabold text-gray-900 animate-bounce">
        404 - Page Not Found
      </h2>
  
      <p className="mt-2 text-sm text-gray-600 hover:opacity-80">
        The page you're looking for doesn't exist or has been moved.
      </p>
  
      <div className="mt-8">
        <button
          onClick={() => navigate('/dashboard')}
          className="w-full py-2 px-4 rounded-md shadow-md text-sm font-medium text-white bg-[#009efb] hover:bg-[#0089db] transition-all duration-300 transform hover:scale-105 active:scale-95"
        >
          Return to Dashboard
        </button>
      </div>
  
    </div>
  </div>
  );
};

export default NotFound; 